<template>
  <div>
    <div id="registration-wrapper">
      <li class="nav-el">
        <div
          v-if="isMobile"
          class="nav-link"
          @click="openModalMobile(false)"
          id="first-login"
        >
          LOGIN
        </div>
        <div
          v-else
          @click="openModal('LOGIN')"
          class="nav-link"
          id="first-login"
        >
          LOGIN
        </div>
      </li>
      <li class="nav-el">
        <div
          v-if="isMobile"
          @click="openModalMobile(true)"
          class="nav-link"
          id="second-login"
        >
          REGISTER
        </div>
        <div
          v-else
          @click="openModal('SIGNUP')"
          class="nav-link"
          id="second-login"
        >
          REGISTER
        </div>
      </li>
    </div>
    <login-register-modal-mobile
      v-if="opened"
      @close="close"
      :type="signUp"
    ></login-register-modal-mobile>
    <login-register-modal></login-register-modal>
  </div>
</template>

<script>
import Modal from "./modal/modal";
import LoginRegisterModal from "./login-register-modal";
import { modalSignals } from "./utils/utils";
import LoginRegisterModalMobile from "./login-register-modal-mobile";
import { responsiveHelper } from "./utils/responsive-helper";

export default {
  name: "login-register-component",
  components: { LoginRegisterModalMobile, LoginRegisterModal, Modal },
  data: function() {
    return {
      isMobile: responsiveHelper.isMobileDevice(),
      opened: false,

      signUp: false,
      loginUrl:
        window.location.origin + "/accounts/login/?next=" + window.location.href
    };
  },
  methods: {
    openModal: function(type) {
      modalSignals.$emit("toggle", "LoginRegisterModal", type, true);
    },
    openModalMobile: function(type) {
      this.opened = true;
      this.signUp = type;
    },
    close: function() {
      this.opened = false;
    }
  }
};
</script>
<style lang="scss">
#registration-wrapper {
  display: flex;
  justify-content: space-between;
  margin: 0 0 0 20px;
  align-items: center;
  .nav-el {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 10px;
    padding: 10px;
    width: 70px;
    color: #0e72ba;
    a {
      text-decoration: none;
    }
    &:hover {
      background-color: transparent;
      border-radius: 6px;
      border: 1px solid #0e72ba;
    }
    .nav-link {
      color: #0e72ba;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/login-register-component.vue